import { get } from 'lodash'
import { SET_ACTIVE_PACKAGE } from '../actions/activePackage'

const activePackage = (state = null, action) => {
  return action.type === SET_ACTIVE_PACKAGE ? action.payload : state
}

export default activePackage

export const getActivePackageData = state => {
  const identifier = state.activePackage
  return state.availablePackages && state.availablePackages[identifier]
    ? state.availablePackages[identifier]
    : null
}

// Bundled pricing is determined per sailing via the pricing data
// (priceInfo.taxesFeesIncluded) rather than the agent's country. For page-level
// content (terms, disclaimers) we treat the active package as bundled when any
// of its guest-count pricing has taxes & fees included.
export const getIsActivePackageBundled = state => {
  const guestCountPricing = get(
    getActivePackageData(state),
    'stateRoomData.guestCountPricing',
    {}
  )
  return Object.values(guestCountPricing || {}).some(pricing =>
    get(pricing, 'bestGuestCountRate.priceInfo.taxesFeesIncluded', false)
  )
}
